import actionCreatorFactory from 'typescript-fsa'
import { AvatarType } from './types'

/**
 * The action creator for this module. Note that it contains the module name.
 */
const actionCreator = actionCreatorFactory('Avatar')

export const updateAvatar = actionCreator<AvatarType>('UPDATE_AVATAR')